import { render, staticRenderFns } from "./SearchResultCollect.vue?vue&type=template&id=3a74ff73&scoped=true"
import script from "./SearchResultCollect.vue?vue&type=script&lang=js"
export * from "./SearchResultCollect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a74ff73",
  null
  
)

export default component.exports